<style>
  .content {
    margin-right: auto;
    .bold {
      font-weight: bold;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  let { licenseTitles = [] } = $props();
  const locale = navigator.language;
  const formatter = new Intl.ListFormat(locale, {
    type: "conjunction",
    style: "long",
  });
  let words = $derived.by(() => formatter.format(licenseTitles));
</script>

<span class="content">
  <span class="bold">Your team is over its license limit for {words}.</span>
</span>
<Button href="/admin" kind="tertiary" leadingIcon="fa-regular fa-tools fa-fw"
  >Go to Admin Page</Button
>
